import { render, staticRenderFns } from "./Kds2StatusMenu.vue?vue&type=template&id=4ab2cdd5"
import script from "./Kds2StatusMenu.vue?vue&type=script&lang=js"
export * from "./Kds2StatusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports